import { Checkbox, Input, Modal, Select, Radio, Typography, notification } from 'antd';
import React, { useContext, useState } from 'react';
import { FormButtons } from '../../commonComponents/buttons/button';
import CustomInput from '../../commonComponents/customInput';
import CommonTable from '../../commonComponents/Table/table';
import { OrderContext } from '../../context/orderContext';
import { useLocation } from 'react-router-dom';
import './order.scss';
const BoxInfoModal = ({ toSideBox = false, isReturnByFlx = false, isReturnBySelf = false, ...props }) => {
    const location = useLocation();
    const [api, contextHolder] = notification.useNotification();
    const { address } = useContext(OrderContext);
    const [companyAddress, setCompanyAddress] = address;
    const [boxInfo, setBoxInfo] = useState({
        dimensions: {
            length: '',
            width: '',
            height: '',
        },
    });
    const [currencyFlag, setCurrencyFlag] = useState(false);
    const [insuranceCurrency, setInsuranceCurrency] = useState('USD');
    const [currencyValue, setCurrencyValue] = useState('');
    const [weightValue, setWeightValue] = useState('');
    const [managedByClient, setManagedByClient] = useState(false);
    const [referenceNumber, setReferenceNumber] = useState('');
    const [trackingNumber, setTrackingNumber] = useState('');
    const [selctedDst, setSelctedDst] = useState(null);

    const generateIdVsOptionsMap = eshipboxes => {
        const finalOptions = {};
        eshipboxes?.forEach(data => {
            data.umbrella.forEach((item, index) => {
                item.boxes.forEach(item => {
                    finalOptions[item.id] = {
                        length: item.outer_length,
                        width: item.outer_width,
                        height: item.outer_height,
                    };
                });
            });
        });
        return finalOptions;
    };

    const handleBoxInfo = data => {
        let name = data.name;
        let inputVal = data.value;
        if (data.name == 'boxName') {
            name = 'dimensions';
            inputVal = generateIdVsOptionsMap(props.eshipboxes)[data.value];
        } else if (['src', 'returnAddress'].includes(data.name)) {
            inputVal = companyAddress.find(elm => elm._id == data.value);
        } else if (data.name == 'weight') {
            inputVal = data.value;
        }
        setBoxInfo({ ...boxInfo, [name]: inputVal });
    };
    // let newUpdata = boxInfo.map((el) => {
    //   console.log(el)
    // })
    const handleAddress = e => {
        const addressObj = companyAddress.find(item => e === item._id);
        setSelctedDst(addressObj);
    };

    const handleConfirmClient = () => {
        if (!referenceNumber?.trim() || !trackingNumber?.trim())
            return api['warning']({
                message: 'Please enter the Reference and Tracking Number',
            });
        if (!selctedDst)
            return api['warning']({
                message: 'Please select an address',
            });
        let finalTemp = {
            selfShippingInfo: {
                referenceNumber: referenceNumber?.trim(),
                trackingNumber: trackingNumber?.trim(),
            },
            managedByClient,
            toAddress: selctedDst,
        };
        props.handleClientBoxCard(finalTemp);
        props.close();
    };
    const handleConfirm = () => {
        let finalTemp = {
            ...boxInfo,
            insurance: {
                isInsured: currencyFlag,
                insuranceAmount: currencyValue,
                insuranceCurrency: insuranceCurrency,
            },
        };
        if (currencyFlag) {
            props.handleBoxCard(finalTemp);
        } else {
            props.handleBoxCard(boxInfo);
        }
        props.close();
    };

    const handleCancel = () => {
        setBoxInfo({
            insured: false,
        });
        props.close();
    };

    const onChangeCurrent = value => {
        setInsuranceCurrency(value);
    };

    const structereBoxDropdown = () => {
        const finalOptions = [];
        props?.eshipboxes?.forEach(data => {
            let countryName = data.origin_country_alpha2;
            let newData = data.umbrella;
            data.umbrella.forEach((item, index) => {
                let name = item.umbrella_name;
                let boxinfo = item.boxes.map(item => {
                    return {
                        label: `${item.name}(${item.display_dimensions})`,
                        value: item.id,
                    };
                });
                finalOptions.push({
                    label: `${countryName}/ ${name}`,
                    options: boxinfo,
                });
            });
        });

        return finalOptions;
    };

    const value = structereBoxDropdown();

    const handleInsuredShipment = () => {
        setCurrencyFlag(!currencyFlag);
    };
    const ByFlixstock = () => {
        return (
            <div className="w-100">
                <div className="box_address w-100 flexAlign-center">
                    <label className="mr-4">{toSideBox ? 'To' : 'From'} Address</label>
                    <Select
                        id="byFlixStock"
                        className="from_address_selector address_selector"
                        placeholder="Select Address"
                        options={companyAddress?.map(elm => {
                            return {
                                value: elm?._id,
                                label: `${elm?.alias},${elm?.addressLine1},${elm?.addressLine2},${elm?.city},${elm?.stateOrProvince},${elm?.country}`,
                            };
                        })}
                        onChange={e => handleBoxInfo({ value: e, name: 'src' })}
                    />
                </div>

                {!isReturnByFlx && (
                    <div className="box_info_div mt-1">
                        <div className="boxname_div mr-4">
                            <label>Box Name</label> <br />
                            <Select
                                options={value}
                                onChange={e => handleBoxInfo({ value: e, name: 'boxName' })}
                                placeholder="select name"
                                name="boxName"
                                style={{
                                    width: '400px',
                                }}
                            />
                        </div>

                        <div className="box_dimensions mr-4">
                            <label>Box Dimensions</label>
                            <div className="dimension_inputs_box">
                                {/* { ['L','B','H'].map(()=>{
          return <CustomInput />
        })} */}
                                <CustomInput customClass="dimensionInputs" name="length" value={boxInfo?.dimensions?.length} />
                                <span>X</span>
                                <CustomInput customClass="dimensionInputs" name="width" value={boxInfo?.dimensions?.width} />
                                <span>X</span>
                                <CustomInput customClass="dimensionInputs mr-1" name="height" value={boxInfo?.dimensions?.height} />
                                <b>cm</b>
                            </div>
                        </div>
                        <div className="weight_div">
                            <label>Weight</label>
                            <br />
                            <div className="flexAlign-center">
                                <Input
                                    claassName="wightInput mr-1"
                                    name="weight"
                                    // onChange={(e)=>setWeightValue(e.target.value)}

                                    // value={boxInfo.dimensions.weight}
                                    onChange={e =>
                                        handleBoxInfo({
                                            value: e.target.value,
                                            name: 'weight',
                                        })
                                    }
                                />
                                <b>Kg</b>
                            </div>
                        </div>
                    </div>
                )}

                {!isReturnByFlx && (
                    <Checkbox
                        className="mt-1 mb-1"
                        name="insured"
                        onChange={e =>
                            handleInsuredShipment({
                                value: e.target.checked,
                                name: e.target.name,
                            })
                        }
                    >
                        Do you want to insure your shipment
                    </Checkbox>
                )}
                <br />
                {/* <CommonTable columns={columns} data={data} bordered /> */}
                {!isReturnByFlx && currencyFlag && (
                    <div
                        style={{
                            display: 'flex',
                            gap: '15px',
                        }}
                    >
                        <label
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                // display: flex;
                                // align-items: center;
                            }}
                        >
                            Value of items in the box :
                        </label>
                        <div>
                            <Input className="currency mr-1" name="currency" onChange={e => setCurrencyValue(e.target.value)} />
                            <Select
                                defaultValue="USD"
                                size="large"
                                onChange={onChangeCurrent}
                                options={[
                                    {
                                        key: 'USD',
                                        value: 'USD',
                                        label: 'USD',
                                    },
                                    {
                                        key: 'INR',
                                        value: 'INR',
                                        label: 'INR',
                                    },
                                    {
                                        key: 'EUR',
                                        value: 'EUR',
                                        label: 'EUR',
                                    },
                                ]}
                            />
                        </div>
                    </div>
                )}
                {!isReturnByFlx && !toSideBox && (
                    <div className="return_address w-100 mt-1 flexAlign-center">
                        <label className="mr-4">Return Address</label>
                        <Select
                            className="return_address_selector address_selector"
                            placeholder="Select Address"
                            options={companyAddress?.map(elm => {
                                return {
                                    value: elm?._id,
                                    label: `${elm?.alias},${elm?.addressLine1},${elm?.addressLine2},${elm?.city},${elm?.stateOrProvince},${elm?.country}`,
                                };
                            })}
                            onChange={e =>
                                handleBoxInfo({
                                    value: e,
                                    name: 'returnAddress',
                                })
                            }
                        />
                    </div>
                )}
                <FormButtons colSpan={22} onConfirm={handleConfirm} onCancel={handleCancel} />
            </div>
        );
    };
    const ByClient = () => {
        return (
            <div className="byClient">
                <div className="flexInput flexAlign">
                    <label style={{ width: '110px' }}>{toSideBox ? 'To' : 'From'} Address</label>
                    <Select
                        className="from_address_selector address_selector"
                        placeholder="Select Address"
                        id="byClient"
                        options={companyAddress?.map(elm => {
                            return {
                                value: elm?._id,
                                label: `${elm?.alias},${elm?.addressLine1},${elm?.addressLine2},${elm?.city},${elm?.stateOrProvince},${elm?.country}`,
                            };
                        })}
                        onChange={e => handleAddress(e)}
                    />
                </div>
                <div className="flexInput flexAlign">
                    <Typography.Text level={5} style={{ width: '125px' }}>
                        Tracking / AWB :{' '}
                    </Typography.Text>
                    <Input onChange={e => setTrackingNumber(e.target.value)} />
                </div>
                <div className="flexInput flexAlign">
                    <Typography.Text level={5} style={{ width: '125px' }}>
                        Reference :{' '}
                    </Typography.Text>
                    <Input onChange={e => setReferenceNumber(e.target.value)} />
                </div>
                <FormButtons colSpan={22} onConfirm={handleConfirmClient} onCancel={handleCancel} />
            </div>
        );
    };

    const handleManagedBy = e => {
        setManagedByClient(e.target.value);
        if (e.target.value) {
            return;
        }
    };

    return (
        <Modal open={props.open} closable={props.closable ? props.closable : false} onCancel={props.close} footer={null} width={'55%'} className="boxInfo-modal">
            {' '}
            {contextHolder}
            {console.log('location: ', location)}
            {location.pathname === '/bookingDetails' && (
                <Radio.Group onChange={handleManagedBy} value={managedByClient} className="mb-1">
                    <Radio value={false}>Managed By Flixstock</Radio>
                    <Radio value={true}>Managed By Client</Radio>
                </Radio.Group>
            )}
            {managedByClient ? ByClient() : ByFlixstock()}
        </Modal>
    );
};

export default BoxInfoModal;
